import React, { useState, useEffect } from 'react';
import { Input, Button, Popup } from 'zarm';
import classname from 'classnames';
import { Icon } from '@iyunbao/components';
import { events } from '@iyunbao/utils';
import LockScroll from '../../../lockScroll';

import {
  certTypeMaps,
  getViewHeight,
  requestAddressBookPage,
  requestSearch,
  requestMore,
} from '../_util';

export interface AddressBookProps {
  prefixCls?: string;
  visible: boolean;
  className?: string;
  onClose?: () => void;
  onChange?: (item: any) => void;
  onLog?: (name: string) => void;
}

export interface ListProps {
  prefixCls?: string;
  dataSource: any;
  searchData: any[];
  focus?: boolean;
  isRequest?: boolean;
  onChange?: (item: any) => void;
  onChangeMore?: (key: string) => void;
}

// 客户列表
function AddressBookList(props: ListProps): any {
  const {
    prefixCls,
    dataSource,
    searchData,
    focus,
    isRequest,
    onChange,
    onChangeMore,
  } = props;

  function subItemNode(data: any[]) {
    if (!(data && Array.isArray(data) && data.length)) {
      return null;
    }

    return data.map((sItem, index) => (
      <div
        className={`${prefixCls}-item`}
        // eslint-disable-next-line react/no-array-index-key
        key={`item_${index}`}
        onClick={() => onChange && onChange(sItem)}
      >
        <div className="item-name">{sItem ? sItem.name : ''}</div>
        <div className="item-content">{(certTypeMaps && Object.keys(certTypeMaps).length && sItem.certiType) ? certTypeMaps[sItem.certiType] : ''}  {sItem.certiNo}</div>
      </div>
    ));
  }

  // 搜索列表
  if (focus) {
    if (searchData && Array.isArray(searchData) && searchData.length) {
      return subItemNode(searchData);
    }

    return (
      <div className="not-list">
        没有匹配的结果
      </div>
    );
  }

  if (!(dataSource && Object.keys(dataSource).length)) {
    // 接口未请求，等待结果
    if (!isRequest) {
      return null;
    }

    return (
      <div className="not-list">
        没有客户
      </div>
    );
  }

  return Object.keys(dataSource).map((key, index) => {
    const { customerVOList, hasNext } = dataSource[key] || {};
    return (
      <div
        className={`${prefixCls}-list`}
        key={`item_${key || index}`}
      >
        <div className={`${prefixCls}-sub-title`}>{key}</div>
        {subItemNode(customerVOList)}
        {
          hasNext && (
            <div
              className={`${prefixCls}-more`}
              onClick={() => onChangeMore && onChangeMore(key)}
            >
              <span>查看更多</span>
            </div>
          )
        }
      </div>
    );
  });
}

let timer: any = null;

/**
 * 通讯录UI
 * @param props
 */
function ImportCustomers(props: AddressBookProps) {
  const {
    prefixCls = 'crm-address-book',
    className,
    visible,
    onClose,
    onChange,
    onLog,
  } = props;
  const [focus, setFocus] = useState(false);
  const [value, setValue] = useState('');
  const [style, setStyle] = useState({});
  const [isRequest, setIsRequest] = useState(false);
  const [bookData, setBookData] = useState({});
  const [searchData, setSearchData] = useState([]);
  const [pages, setPages] = useState({});
  // 手动触发
  const [handUpload, setHandUpload] = useState(false);

  const cls = classname(prefixCls, className);
  const searchCls = classname(`${prefixCls}-search`, {
    [`${prefixCls}-search-focus`]: focus,
  });

  useEffect(() => {
    // 初始化客户列表
    requestAddressBookPage()
      .then((result: any) => {
        setBookData(result);
        setIsRequest(true);
      });

    setStyle(getViewHeight());

    events.on(window, 'resize', () => {
      setStyle(getViewHeight());
    });
  }, []);

  // 加载列表更多
  function onChangeMore(key: string) {
    const page = (pages[key] || 0) + 1;

    const params = {
      alphabet: key,
      pageNo: page,
    };

    requestMore(params)
      .then((result: any) => {
        if (result && Object.keys(result).length) {
          const { hasNext, customerVOList } = result || {};
          const currentData = bookData[key];

          currentData.hasNext = hasNext;
          currentData.customerVOList = currentData.customerVOList.concat(customerVOList);

          pages[key] = page;

          setBookData(bookData);
          setPages(pages);
          // 组件不触发，手动触发
          setHandUpload(!handUpload);
        }
      });
  }

  // 搜索
  function onChangeSearch(val: string) {
    // 用于埋点标记，回调
    onLog && onLog('searchAddressBook');

    requestSearch(val)
      .then((content: any) => {
        setSearchData(content);
      });
  }

  // 搜索模块
  const searchNode = (
    <div className={searchCls}>
      <div className={`${prefixCls}-search-inner`}>
        <Icon type="sousuo" />
        <Input
          placeholder="请输入姓名"
          className="input-search"
          value={value}
          onFocus={() => setFocus(true)}
          onChange={(val: string) => {
            setValue(val);

            timer && clearTimeout(timer);
            timer = setTimeout(() => {
              onChangeSearch(val);
            }, 800);
          }}
        />
        <Button
          shape="round"
          theme="primary"
          className="button-search"
        >
          搜索
        </Button>
      </div>
      <div
        className="button-cancel"
        onClick={() => {
          setFocus(false);
          setValue('');
        }}
      >
        取消
      </div>
    </div>
  );

  return (
    <LockScroll>
      <Popup
        visible={visible}
        className={cls}
        onMaskClick={() => onClose && onClose()}
      >
        {searchNode}
        <div
          className={`${prefixCls}-body`}
          style={style}
        >
          <AddressBookList
            prefixCls={prefixCls}
            dataSource={bookData}
            searchData={searchData}
            focus={focus}
            isRequest={isRequest}
            onChange={(item) => onChange && onChange(item)}
            onChangeMore={(key) => onChangeMore(key)}
          />
        </div>
      </Popup>
    </LockScroll>
  );
}

export default ImportCustomers;
